import { render, staticRenderFns } from "./vueperslides.vue?vue&type=template&id=60ab49a0&lang=pug&"
import script from "./vueperslides.vue?vue&type=script&lang=js&"
export * from "./vueperslides.vue?vue&type=script&lang=js&"
import style0 from "./vueperslides.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports